/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreatePromotion201Response
 */
export interface CreatePromotion201Response {
    /**
     * 
     * @type {string}
     * @memberof CreatePromotion201Response
     */
    id: string;
}

/**
 * Check if a given object implements the CreatePromotion201Response interface.
 */
export function instanceOfCreatePromotion201Response(value: object): value is CreatePromotion201Response {
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function CreatePromotion201ResponseFromJSON(json: any): CreatePromotion201Response {
    return CreatePromotion201ResponseFromJSONTyped(json, false);
}

export function CreatePromotion201ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreatePromotion201Response {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
    };
}

export function CreatePromotion201ResponseToJSON(json: any): CreatePromotion201Response {
    return CreatePromotion201ResponseToJSONTyped(json, false);
}

export function CreatePromotion201ResponseToJSONTyped(value?: CreatePromotion201Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
    };
}

